import {BotMessageObject, AgentMessageObject, FeedbackRatingMessage, FeedbackReasonMessage} from '../../types/chat';
import {ClientErrorLogger} from './clientErrorLogger';
import AbstractChatConnector from '../chat/connector/abstractChatConnector';
import {ChatMessageHandler} from '../chat/chatMessageHandler';
import {ChatFeedbackHandler} from "../chat/chatFeedbackHandler";

export function waitForSocketConnection(
    socket: WebSocket | null,
    onReady: (socket: WebSocket, object: any, onError: () => void) => void,
    onError: () => void,
    object: object,
    currentRetry: number = 0
): void {
    if (!socket) {
        onError();
        return;
    }

    setTimeout(() => {
        if (socket.readyState === WebSocket.OPEN) {
            onReady(socket, object, onError);
        } else if (currentRetry < 20) {
            waitForSocketConnection(socket, onReady, onError, object, currentRetry + 1);
        } else {
            onError();
        }
    }, 250);
}

export async function trySendMessage(
    webSocket: WebSocket | null,
    messageObject: BotMessageObject | AgentMessageObject | FeedbackRatingMessage | FeedbackReasonMessage,
    errorHandler: () => void,
    messageHandler: ChatMessageHandler | ChatFeedbackHandler,
    chatConnector: AbstractChatConnector,
    retry: boolean = false
): Promise<void> {
    // Prüfe, ob Socket null ist und versuche ggf. Verbindungsaufbau
    if (!webSocket) {
        await chatConnector.initConnection();
        webSocket = await chatConnector.getWebSocket();
        if (!webSocket) {
            (new ClientErrorLogger()).logError('Websocket konnte nicht aufgebaut werden', {
                reason: 'Websocket null nach initConnection',
                messageType: chatConnector.getChatType()
            });
            errorHandler();
            return;
        }
    }

    try {
        waitForSocketConnection(
            webSocket,
            (socket, object, onError) => messageHandler.handleSendMessage(socket, object, onError),
            errorHandler,
            messageObject
        );
    } catch (error) {
        (new ClientErrorLogger()).logError(error, {
            reason: retry ? 'Retry failed' : 'Websocket nicht im OPEN-Status',
            messageType: chatConnector.getChatType(),
            websocket: webSocket
        });
        if (!retry) {
            await chatConnector.initConnection();
            webSocket = await chatConnector.getWebSocket();
            if (webSocket) {
                await trySendMessage(
                    webSocket,
                    messageObject,
                    errorHandler,
                    messageHandler,
                    chatConnector,
                    true
                );
                return;
            }
        }
        errorHandler();
    }
}
